<template>
  <div v-if="showApp">
    <etat-des-lieux-materiel></etat-des-lieux-materiel>
  </div>
</template>

<script>
import EtatDesLieuxMateriel from "@/projects/etat-des-lieux-materiel/component/page-home.vue";

export default {
  data() {
    return {
      showApp: false,
    };
  },
  mounted() {
    let appsToShow = this.$store.state.webApplicationToShow;
    let currentApp = this.$route.fullPath.replace("/", "").split('?')[0];
    if (appsToShow.includes(currentApp)) this.showApp = true;
  },
  components: {
    EtatDesLieuxMateriel,
  },
};
</script>

<style>
</style>